<script>
  import ListMain from '../../../../app/components/list/Main.vue'
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEditButton from '../../../../app/components/list/EditButton.vue'
  import ListDeleteButton from '../../../../app/components/list/DeleteButton.vue'
  import bus from '@utils/bus'
  import {isEmpty} from 'lodash'
  import {mapGetters} from 'vuex'

  export default {
    components: {ListMain, ListHeader, ListEditButton, ListDeleteButton},
    data () {
      return {
        isLoadingData: true,
        filters: {},
        dependencies: {}
      }
    },
    mounted () {
      bus.$emit('list-init', {domain: 'layout'}, () => {
        this.isLoadingData = false
      })
    },
    computed: {
      ...mapGetters(['listStore'])
    },
    methods: {
      onFilter () {
        const searchData = {}
        if (!isEmpty(this.filters.name)) {
          searchData.name = {
            'ilike': '%' + this.filters.name + '%'
          }
        }
        bus.$emit('list-filter', this.filters, searchData)
      },
      onFilterClean () {
        this.filters = {}
        bus.$emit('list-filter-clean', this.filters)
      },
      onDestroy (item) {
        bus.$emit('list-destroy-item', item)
      }
    },
    beforeMount () {
      this.listStore.listData = []
    }
  }
</script>

<template>
    <div>

        <ListHeader title="Layouts dos Certificados" store-route-name="layout.store"/>

        <ListMain>

            <div slot="filters">
                <el-card class="el-card__search_list box-card">
                    <div slot="header">
                        <span>Filtrar</span>
                        <div>
                            <el-button type="primary" @click="onFilter">Pesquisar</el-button>
                            <el-button type="default" @click="onFilterClean">Limpar</el-button>
                        </div>
                    </div>
                    <el-form :inline="true" :model="filters" class="demo-form-inline">
                        <el-form-item label="Nome">
                            <el-input v-model="filters.name"
                                      placeholder="Filtrar por nome"
                                      @keydown.enter.native.prevent="onFilter"/>
                        </el-form-item>
                    </el-form>
                </el-card>
            </div>

            <div slot="list" v-if="!isLoadingData">

                <h2>Lista de Campos</h2>
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Nome</th>
                        <th>Descrição</th>
                        <th class="btn-actions">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in listStore.listData">
                        <td>{{item.id}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.description}}</td>
                        <td>
                            <div class="btn-actions">
                                <ListEditButton route-name="layout.update" :item="item" domain="layout"/>
                                <ListDeleteButton :item="item" domain="layout"/>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>

        </ListMain>
    </div>
</template>



// WEBPACK FOOTER //
// List.vue?9bf0427c